import React, { PropTypes } from 'react';
import { ReactSparkSelectInput } from '../widgets/index';

const FontPropertySelect = ({ label, values, defaultValue, onChange, themeAccess }) => {
    return (
        <div>
            <ReactSparkSelectInput
                label={label}
                onChange={onChange}
                isDisabled={themeAccess}
                defaultValue={defaultValue}
                values={values.map(v => {
                    return { key: v.toString(), label: v.toString() };
                })}
            />
        </div>
    );
};

FontPropertySelect.propTypes = {
    label: PropTypes.string,
    values: PropTypes.array,
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    themeAccess: PropTypes.bool
};

export default FontPropertySelect;



// WEBPACK FOOTER //
// ./src/components/common/FontPropertySelect.js